module.exports = __webpack_public_path__ + "static/media/microscopy-yliv-01 5.100f0cce.png";